import { render, staticRenderFns } from "./AdminPackageTypeList.vue?vue&type=template&id=94b0eea0"
import script from "./AdminPackageTypeList.vue?vue&type=script&lang=js"
export * from "./AdminPackageTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports